import { FC } from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { DashboardUtils } from '@/features/dashboard/utils/dashboardUtils';
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';

type Props = {};

const DashboardTotalApartmentsBlockSkeleton: FC<Props> = () => {
	const { t } = useTranslation();

	const {
		icon: Icon,
		iconClasses,
		iconBgClasses,
	} = DashboardUtils.getAllChartsConfig('totalApartments');

	return (
		<div className='p-6 flex grow  flex-col gap-6 border border-popover-100 rounded-2.5xl bg-popover-10 select-none'>
			<div className='flex items-center gap-4'>
				<div
					className={cn(
						'size-8 flex items-center justify-center rounded-semi-xl',
						iconBgClasses,
					)}>
					<Icon className={iconClasses} />
				</div>
				<h4 className='text-xl font-medium'>{t('Total owners')}</h4>
			</div>
			<div>
				<Skeleton className='h-4 w-30 my-1.5 rounded-full' />
			</div>
			<div className='grow-1 flex flex-col items-center gap-6'>
				<div className='w-full h-4 flex gap-0.5 rounded-full overflow-hidden'>
					{Array.from({ length: 6 }).map((_, index) => (
						<Skeleton key={index} className='h-4 w-full rounded-none' />
					))}
				</div>
				<div className='w-full h-60 flex flex-col gap-6'>
					{Array.from({ length: 6 }).map((_, index) => (
						<div key={index} className='flex items-center gap-2.5'>
							<Skeleton className='h-3 w-3 my-1 rounded-full' />
							<Skeleton className='h-3 w-16 my-1 rounded-full' />
							<Skeleton className='h-3 w-16 my-1 ml-auto rounded-full' />
						</div>
					))}
				</div>
			</div>
			<Skeleton className='h-11 w-full rounded-full' />
		</div>
	);
};

export default DashboardTotalApartmentsBlockSkeleton;
